import { Col, Row } from 'antd';
import { FORMAT_DATE_FOR_DISPLAY_FULL } from 'constants/days';
import moment from 'moment';
import React, { useMemo } from 'react';
import { formatAddress } from 'utils';

import { IInvoicePaymentProps } from './types';

const InvoiceDetailHeader: React.FC<IInvoicePaymentProps> = ({
  invoice,
  invoiceTargetNotary,
  invoiceTargetCompany,
}) => {
  const { name, address } = useMemo(() => {
    if (invoiceTargetNotary) {
      return {
        name: `${invoiceTargetNotary?.firstName} ${invoiceTargetNotary?.lastName}`,
        address: formatAddress(invoiceTargetNotary),
      };
    }
    if (invoiceTargetCompany) {
      return {
        name: invoiceTargetCompany.name,
        address: formatAddress(invoiceTargetCompany.address),
      };
    }
    return {};
  }, []);

  return (
    <Row>
      <Col span={24} sm={9}>
        <div className='customer-tag'>Customer</div>
        <div className='gx-font-weight-medium customer-name'>{name}</div>
        <div className='customer-address'>{address}</div>
      </Col>
      <Col span={24} sm={7} className='invoice-info'>
        <div className='gx-font-weight-medium' style={{ fontSize: 16 }}>
          Invoice: #{invoice?.invoiceId}
        </div>
        <div>{moment(invoice?.createdAt || '').format(FORMAT_DATE_FOR_DISPLAY_FULL)}</div>
      </Col>
      <Col span={24} sm={8} className='invoice-total'>
        <span>Total Paid: </span>
        <span className='invoice-total-number'>${invoice?.total}</span>
      </Col>
    </Row>
  );
};

export default React.memo(InvoiceDetailHeader);
